/*
 * --------------------------------------------------------------------------- *
 * File: gsk-login-form.tsx                                                    *
 * Project: @gsk-tech/gsk-react-framework                                      *
 * Created Date: Monday, 11th July 2022 11:40:57 am                            *
 * Author: Alex E Benn                                                         *
 * -----                                                                       *
 * Last Modified: Tue Apr 11 2023                                              *
 * Modified By: Alex E Benn                                                    *
 * -----                                                                       *
 * Copyright (c) 2022 GSK                                                      *
 * -----                                                                       *
 * HISTORY:                                                                    *
 * Date      	By	Comments                                                     *
 * --------------------------------------------------------------------------- *
 */
import './gsk-login-form.css'

import { Button, Checkbox, Form, Input, message } from 'antd'
import React, { useState } from 'react'
import { useDispatch } from 'react-redux'
import { EHttpStatusCode, IReduxAction } from '@gsk-tech/gsk-react-framework'



const layout = {
	labelCol: {
		span: 8,
	},
	wrapperCol: {
		span: 16,
	},
}

const tailLayout = {
	wrapperCol: {
		offset: 8,
		span: 16,
	},
}

export interface IAuthenticationProps {
	action: (username: string, password: string) => IReduxAction
	actionSuccess?: string
	selector?: any
}
export interface ICredentials {
	password: string
	remember: boolean
	username: string
}

export const GSKLoginForm: React.FC<IAuthenticationProps> = (
	props: IAuthenticationProps
) => {

	const dispatch: any = useDispatch()
	const [disabled, setDisabled] = useState(false)

	const enableSubmit = () => {
		setDisabled(false)
	}

	const onFinish = (values: any): void => {

		setDisabled(true)

		dispatch(props.action(values.username, values.password)).then((response: any) => {
			//dispatch(fetchAuthTokenAction(values.name, values.password)).then((response: { action: any, data: any, error: any }) => {
			//const { data, error } = await dispatch(fetchAuthTokenAction(values.name, values.password))
			//console.log(response)

			// Use selector to check response is OK (i.e. 200)
			if (response.action.type !== props.actionSuccess) {

				let msg: string

				switch (response.action.error?.response?.status) {
					case EHttpStatusCode.Unauthorized:
						msg = 'Incorrect username or password entered'
						break

					default:
						if (response.action.error.message !== undefined) {
							msg = response.action.error.message
						} else {
							msg = 'Unknown Error'
						}
				}
				message.error(msg, 1, enableSubmit)
			}
		})
	}

	const onFinishFailed = (errorInfo: any) => {
		console.log('Failed:', errorInfo)
	}

	return (
		<div className="gsk-login-form-main">
			<Form
				{...layout}
				name="basic"
				initialValues={{
					remember: true,
				}}
				onFinish={onFinish}
				onFinishFailed={onFinishFailed}
				autoComplete="off"
			>
				<Form.Item
					label="Username"
					name="username"
					rules={[
						{
							message: 'Please input your username',
							required: true,
						},
					]}
				>
					<Input />
				</Form.Item>

				<Form.Item
					label="Password"
					name="password"
					rules={[
						{
							message: 'Please input your password',
							required: true,
						},
					]}
				>
					<Input.Password />
				</Form.Item>

				<Form.Item {...tailLayout} name="remember" valuePropName="checked">
					<Checkbox>Remember me</Checkbox>
				</Form.Item>

				<Form.Item {...tailLayout}>
					<Button type="primary" htmlType="submit" disabled={disabled}>
						Submit
					</Button>
				</Form.Item>
			</Form>
		</div>
	)
}
export default GSKLoginForm
